export default "__VITE_ASSET__534ec6ba__"